import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { AbstractApiService } from '../../shared/services';
import { AbstractApiResponse } from '../../shared/models';
import * as fromModuleModels from '../models';
import { Salutation } from '../models';
import { UserRoleService } from '../../shared/services/user-role.service';

@Injectable()
export class SalutationsService {
  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  createSalutation(
    payload: fromModuleModels.Salutation
  ): Observable<fromModuleModels.Salutation> {
    return this.rolesService.userHasRoleFilter<Salutation>(
      'ROLE_MWS_CUSTOMER_SALUTATION_CREATE',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.createObject(`/salutations`, payload)
    );
  }

  getSalutation(iri: string): Observable<fromModuleModels.Salutation> {
    return this.rolesService.userHasRoleFilter<Salutation>(
      'ROLE_MWS_CUSTOMER_SALUTATION_VIEW',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(iri, true)
    );
  }

  getSalutations(): Observable<AbstractApiResponse | any> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_CUSTOMER_SALUTATION_LIST',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(`/salutations`)
    );
  }

  updateSalutation({ iri, payload }): Observable<fromModuleModels.Salutation> {
    return this.rolesService.userHasRoleFilter<Salutation>(
      'ROLE_MWS_CUSTOMER_SALUTATION_EDIT',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.updateObject(iri, payload, true)
    );
  }

  deleteSalutation(iri: string): Observable<AbstractApiResponse> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_CUSTOMER_SALUTATION_DELETE',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.deleteObject(iri, true)
    );
  }
}
